<header
    class="sticky top-0 z-50 w-full bg-white sm:px-6 px-4 py-3 border-b border-[#E7EAF0] flex items-center justify-between">
    <div class="flex item-center sm:space-x-[15vw] space-x-2 sm:w-56 w-full">
        <!-- Logo -->
        <div class="flex items-center flex-shrink-0">
            <img src="/assets/images/auth/interseed-logo-horizontal.png" alt="Interseed Logo" class="h-10 w-auto" />
        </div>
    </div>

    <div class="flex-1">
        <div class="max-w-2xl mx-auto sm:px-4 flex items-center justify-between">
            <!-- Desktop: Search -->
            <div class="relative hidden sm:block" (click)="openSearchPopup()">
                <img
                    src="/assets/images/shared/search-icon.svg"
                    alt="Toggle password visibility"
                    class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-auto cursor-pointer" />
                <input
                    type="text"
                    placeholder="Search..."
                    class="md:w-[384px] search-form-field-container cursor-pointer hover:shadow-md transition-shadow" />
            </div>

            <!-- Desktop -->
            <div class="hidden sm:flex items-center gap-2">
                <!-- Notification -->
                <app-notification-dropdown></app-notification-dropdown>
                <!-- Profile Dropdown -->
                <app-profile-dropdown></app-profile-dropdown>
            </div>

            <!-- Mobile -->
            <div class="sm:hidden flex items-center gap-2">
                <button type="button" class="flex items-center justify-center size-9">
                    <img
                        src="/assets/images/shared/search-icon.svg"
                        alt="Search icon"
                        class="h-5 w-auto"
                        (click)="openSearchPopup()" />
                </button>
                <button type="button" class="flex items-center justify-center size-9">
                    <img
                        src="/assets/images/auth/sign-out-red-icon.svg"
                        alt="Signout"
                        class="h-5 w-auto"
                        (click)="openSignOutPopup()" />
                </button>
            </div>
        </div>
    </div>
</header>
